<app-navbar-style-one></app-navbar-style-one>




<div class="earnings-box">
    <div class="container booking-form">
        <form #login="ngForm" [formGroup]="loginForm" (ngSubmit)="loginFunction(login)">
            <div class="row">
                <div class="form-group col-lg-12">
                    <label for="">Upline Name</label>
                      <input type="text"  [class.is-invalid]="login.submitted && loginForm.get('loginName').invalid" formControlName="loginName" placeholder="Enter Username" class="form-control">
                                <div class="invalid-feedback">Please Enter Username</div>
                </div>
                <div class="form-group col-lg-12">
                    <label for="">Password</label>
                         <input type="password"  [class.is-invalid]="login.submitted && loginForm.get('password').invalid" formControlName="password" placeholder="Enter Password" class="form-control">
                                <div class="invalid-feedback">Please Enter Password</div>
                </div>
            </div>
            <button type="submit">Login</button>
        </form>
       
</div>